import { PATHS } from '@/routes/paths';
import { RedirectConfig } from '@/routes/Redirects/Redirect';

const legacyAnalysisRedirects = (prefix: string): RedirectConfig[] => [
  { from: prefix, to: PATHS.statusQuoAnalysis.buildings },
  { from: `${prefix}/buildings`, to: PATHS.statusQuoAnalysis.buildings },
  { from: `${prefix}/buildings/:id`, to: PATHS.statusQuoAnalysis.building },
  { from: `${prefix}/portfolio`, to: PATHS.statusQuoAnalysis.portfolio },
  { from: `${prefix}/economic-unit`, to: PATHS.statusQuoAnalysis.economicUnits },
  { from: `${prefix}/transaction`, to: PATHS.statusQuoAnalysis.economicUnits },
];

export const getRedirects = (): RedirectConfig[] => {
  return [
    // Old Analysis paths redirect to new Analysis paths
    ...legacyAnalysisRedirects('/status-quo-analysis'),
    {
      from: '/status-quo-analysis/:hash',
      to: (params?: { hash?: string }) => `/analysis/${params?.hash ?? ''}`,
    },
    // Old ESG Analysis redirects to new Analysis paths
    ...legacyAnalysisRedirects('/esg-analysis'),
    {
      from: '/action-planning',
      to: PATHS.actionPlanning.scenarios,
    },
    {
      from: '/action-planning/actionplan/:id',
      to: PATHS.actionPlanning.scenarios,
    },
    {
      from: '/data-collection/building-draft/:id',
      to: PATHS.dataCollection.buildingDraft,
    },
    {
      from: '/data-collection/building/:id/consumption/:consumptionId',
      to: PATHS.dataCollection.buildingConsumptionInvoice,
    },
    {
      from: '/data-collection/building/:id',
      to: PATHS.dataCollection.building,
    },
    {
      from: '/org/user/:id',
      to: PATHS.org.user,
    },
    {
      from: '/data-collection/emission-certificates',
      to: PATHS.dataCollection.energySuppliers,
    },
    {
      from: '/data-collection/emission-certificate/:id',
      to: PATHS.dataCollection.energySupplier,
    },
    {
      from: '/data-collection/emission-certificate-draft/:id',
      to: PATHS.dataCollection.energySupplierDraft,
    },
    {
      from: '/data-collection/emission-certificate-drafts',
      to: PATHS.dataCollection.energySupplierDrafts,
    },
    {
      from: '/org/portfolios',
      to: PATHS.dataCollection.portfolios,
    },
  ];
};
